// src/MainPage.js
import React, { useState, useEffect } from "react";
import { logEvent } from "./logger"; 

export default function MainPage({ user, displayName, items: allItems, addToCart }) {
  const categories = ["সবগুলো", "বিরিয়ানি", "মাছ", "মাংস", "কাবাব", "স্ন্যাকস", "ডেজার্ট", "ড্রিংকস", "চা-কফি", "দেশি","স্ট্রিট‑ফুড"];

  const [activeTab, setActiveTab] = useState("সবগুলো");
  const [searchText, setSearchText] = useState("");
  const [items, setItems] = useState(allItems);

  useEffect(() => {
    let filtered = allItems;
    
    // ক্যাটাগরি ফিল্টার
    if (activeTab !== "সবগুলো") {
      filtered = filtered.filter(f => f.category === activeTab);
    }
    
    // সার্চ ফিল্টার (একাধিক স্পেস হ্যান্ডেল করবে)
    if (searchText.trim()) {
      filtered = filtered.filter(f => 
        f.name.toLowerCase().includes(searchText.toLowerCase().trim())
      );
    }
    
    setItems(filtered);
  }, [activeTab, searchText, allItems]);

  return (
    <div className="p-4 md:p-12 bg-gray-50 min-h-screen">
      
      {/* ব্যানার */}
      <div className="mb-10">
        <div className="bg-black rounded-[40px] py-20 px-10 text-center shadow-2xl border-b-4 border-[#D70F64]">
          <h1 className="text-white text-3xl md:text-5xl font-black font-Kalpana">
            ঐতিহ্যের স্বাদে  আধুনিক স্পর্শে <span className="text-[#ff006a] text-1xl font-sans"> Ap Food</span>
          </h1>
        </div>
      </div>

      <h1 className="text-2xl md:text-3xl font-black text-gray-800 mb-6 px-2">
        Welcome <span className="text-[#D70F64]">{displayName}</span>!
      </h1>

      {/* সার্চ বার - আইকন পজিশন ঠিক করা হয়েছে */}
      <div className="relative mb-10 group">
        <input
          type="text"
          placeholder="সার্চ করুন আপনার পছন্দের খাবার..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full md:w-1/2 p-5 bg-white border-2 border-transparent rounded-[25px] outline-none focus:border-[#D70F64] shadow-[0_15px_40px_rgba(0,0,0,0.08)] transition-all font-bold placeholder-gray-400"
        />
        {/* আইকনটি ইনপুটের একদম ভেতরে ডানে রাখা হয়েছে */}
        <span className="absolute left-[44%] md:left-[45%] top-5 text-gray-400 hidden md:block text-xl group-focus-within:text-[#D70F64] transition-colors">🔍</span>
      </div>

      {/* ক্যাটাগরি ট্যাব */}
      <div className="flex flex-wrap gap-3 mb-10 overflow-x-auto pb-2 scrollbar-hide">
        {categories.map(cat => (
          <button
            key={cat}
            className={`px-6 py-2.5 rounded-full font-bold whitespace-nowrap transition-all ${
              activeTab === cat 
                ? "bg-[#D70F64] text-white shadow-lg scale-105" 
                : "bg-white text-gray-600 border border-gray-200 hover:bg-gray-100"
            }`}
            onClick={() => setActiveTab(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* কার্ড গ্রিড */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {items.map(item => (
          <div key={item.id} className="bg-white rounded-[35px] shadow-sm p-4 flex flex-col justify-between hover:shadow-2xl transition-all duration-300 border border-gray-100 group">
            <div className="overflow-hidden rounded-[25px] relative">
              <img 
                src={item.image} 
                alt={item.name} 
                className="w-full h-56 object-cover group-hover:scale-110 transition duration-500" 
                loading="lazy" 
              />
              <div className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm px-4 py-1.5 rounded-full text-[#D70F64] font-black shadow-md">৳{item.price}</div>
            </div>
            
            <div className="mt-5 px-1">
              <h3 className="font-black text-xl text-gray-800 group-hover:text-[#D70F64] transition-colors">{item.name}</h3>
              <p className="text-gray-400 text-sm font-medium">Delicious Home Made Food</p>
            </div>

            <div className="flex flex-col mt-6 gap-3">
              <button 
                onClick={() => addToCart(item)} 
                className="bg-[#D70F64] text-white p-4 rounded-2xl font-black w-full shadow-lg shadow-pink-50 hover:brightness-110 active:scale-95 transition-all"
              >
                Add to Cart
              </button>
              <button 
                onClick={() => {
                  if (!user) { alert("অর্ডার করতে লগইন করুন!"); return; }
                  addToCart(item);
                  logEvent("order", `${user.email} অর্ডার করেছেন: ${item.name}`);
                  alert(`অর্ডার হয়েছে: ${item.name}`);
                }}
                className={`bg-gray-900 text-white p-4 rounded-2xl font-black w-full hover:bg-black transition-all ${!user ? "opacity-30 cursor-not-allowed" : "active:scale-95"}`}
              >
                অর্ডার নাও
              </button>
            </div>
          </div>
        ))}
      </div>

      {items.length === 0 && (
        <div className="text-center py-20">
          <p className="text-6xl mb-4">🍽️</p>
          <p className="text-gray-400 font-bold italic text-xl">দুঃখিত, খাবার খুঁজে পাওয়া যায়নি!</p>
        </div>
      )}
    </div>
  );
}